import React from 'react';
import Input from '../Input';
import Hero1 from '../../img/hero_image_1.webp'
import Hero2 from '../../img/hero_image_2.webp'
import Hero3 from '../../img/hero_image_3.webp'
import Image from '../Image';
import { useState, useEffect, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Hero() {

    const [activeSlide, setActiveSlide] = useState(1);

    const [slideTitle, setSlideTitle] = useState("Explore the Current Issue");

    const [slideButtonContent, setSlideButtonContent] = useState("Read Now");

    const [slideUrl, setSlideUrl] = useState("");

    const [slideActiveImage, setSlideActiveImage] = useState(1);

    const [latestIssue, setLatestIssue] = useState([]);

    useEffect(() => {
            fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues')
              .then(res => res.json())
              .then(data => {
                if (data.success) {
                  const publishedIssues = data.issues
                    .filter(issue => issue.publish === 1)
                    .slice(0, 1);
        
                  setLatestIssue(publishedIssues.id);

                  console.log(publishedIssues[0].id)

                  setSlideUrl(`/articles?issue=${publishedIssues[0].id}`)
                }
              })
              .catch(err => console.error('Failed to fetch issues:', err));
    }, []);

    const slides = useMemo(() => {
        return [
            {
                slide_title: "Explore the Current Issue",
                slide_url: `/articles?issue=${latestIssue}`,
                slide_button_content: "Read Now",
                line_color: "#0b396c",
                active_image:1,
                text_block_color:"rgba(11, 57, 108,0.8)"
            },
            {
                slide_title: "Discover All Articles",
                slide_url: "/articles",
                slide_button_content: "Browse Articles",
                line_color: "#741313",
                active_image:2,
                text_block_color:"rgb(116, 19, 19, 0.8)"
            },
            {
                slide_title: "Meet the Editorial Board",
                slide_url: "/editorial",
                slide_button_content: "Learn More",
                line_color: "#02152b",
                active_image:3,
                text_block_color:"rgba(2, 21, 43, 0.8)"
            }
        ];
    }, []);

    useEffect(() => {
        function wait(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
    
        let intervalActive = true;
    
        const startAnimation = async () => {
            const colorLineEl = document.querySelector('.hero_color_line');
            const textContentEl = document.querySelector('.hero_slider_text_content');
            const textBlockEl = document.querySelector('.hero_slider_text');

            if (!colorLineEl || !textContentEl || !textBlockEl) return;

            while (intervalActive) {
                // Start the color background block animation
                colorLineEl.style.top = "0px";
                colorLineEl.style.right = "0px";
                textContentEl.style.top = "40px";
                textContentEl.style.opacity = "0";

                await wait(600);

                setActiveSlide((prev) => {
                const nextSlide = prev >= slides.length ? 1 : prev + 1;

                // Update content based on the next slide
                colorLineEl.style.background = slides[nextSlide - 1].line_color;
                setSlideTitle(slides[nextSlide - 1].slide_title);
                setSlideButtonContent(slides[nextSlide - 1].slide_button_content);
                setSlideUrl(slides[nextSlide - 1].slide_url);
                setSlideActiveImage(slides[nextSlide - 1].active_image);
                textBlockEl.style.background = slides[nextSlide - 1].text_block_color;

                return nextSlide;
                });

                colorLineEl.style.top = "20px";
                colorLineEl.style.right = "20px";
                textContentEl.style.top = "0px";
                textContentEl.style.opacity = "1";

                await wait(7000);
            }
        };

        setTimeout(()=>{
            startAnimation();
        }, 3000)
    
        return () => {
            intervalActive = false;
        };
    }, [slides.length, slides]);


    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleSearchSubmit = () => {

        const encodedQuery = encodeURIComponent(searchQuery.trim());

        if (location.pathname.includes("articles")) {
            const params = new URLSearchParams(location.search);
            params.set("q", encodedQuery);
            navigate(`${location.pathname}?${params.toString()}`);
        } else {
            navigate(`/articles?q=${encodedQuery}`);
        }
        
    };

    return (
      <>
        <div className="hero_section">
            <div className='hero_wrapper'>
                <div className='hero_content'>
                    <h1 className='hero_title'>
                        Annals of Nursing
                    </h1>
                    <h2 className='hero_subtitle'>
                        A Semi-Annual International Scientific Journal
                    </h2>
                    <p className='hero_paragraph'>
                    {/* Annals of Nursing is the official journal of the Medika College of Vocational Studies in Healthcare, Belgrade Serbia. Co-Publisher is the Faculty of Medicine, University of Montenegro, Podgorica. It is a semi-annual international open access peer reviewed journal that covers all aspects of nursing in hospitals, families and the communities. The papers published in "Annals of Nursing" are freely available to all internet users under the terms of Creative Commons Licence CC BY.
                    <br/><br/>
                    The focus of the journal is on the role of nurses in the promotion of health and the quality of life, prevention of illness, care of disabled and ill people and all suffering individuals and rehabilitation after illness. */}
                    <i>Annals of Nursing</i> is the official journal of the Medika College of Vocational Studies in Healthcare, Belgrade, Serbia. Co-publisher is the Faculty of Montenegro. It is a semi-annual international open-access, peer-reviewed journal that comprehensively covers all aspects of nursing in hospitals, families, and communities. The papers published in <i>Annals of Nursing</i> are freely available to all internet users and may be used for commercial purposes. The journal focuses on the role of nurses in promoting health and quality of life, preventing illness, caring for disabled and ill individuals, and facilitating rehabilitation after illness.
                    </p>

                    <Input
                        type="text"
                        class="hero_search"
                        placeholder="Enter Search Term"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onSearch={handleSearchSubmit}
                    />

                    <div className='search_by_wrapper'>
                
                        Search by:
                        
                        <div className='search_by_block'>article title</div>

                        <div className='search_by_block'>keyword</div>

                        <div className='search_by_block'>author</div>
                    
                    </div>
                </div>
                <div className='hero_slider'>
                    <div className='hero_slider_content'>
                        <div className='hero_image_wrapper'>
                        <Image
                            src={Hero1}
                            alt="Annals of Nursing"
                            class="hero_image"
                            style={{ opacity: slideActiveImage === 1 ? 1 : 0 }}
                        />
                        <Image
                            src={Hero2}
                            alt="Annals of Nursing"
                            class="hero_image"
                            style={{ opacity: slideActiveImage === 2 ? 1 : 0 }}
                        />
                        <Image
                            src={Hero3}
                            alt="Annals of Nursing"
                            class="hero_image"
                            style={{ opacity: slideActiveImage === 3 ? 1 : 0 }}
                        />
                        </div>
                        <div className='hero_slider_text'>
                                <div className="hero_slider_text_content" active-slide={activeSlide}>
                                    <p className="hero_slider_title">{slideTitle}</p>
                                    <Link className="hero_slider_link" to={slideUrl}>
                                        {slideButtonContent}&nbsp;
                                        <span className="fa-solid fa-arrow-right-long"></span>
                                    </Link>
                                </div>
                        </div>
                        <div className='hero_color_line'>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
}

export default Hero;